import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const currentDate = moment();
const formattedDate = currentDate
  .format("YYYY-MM-DDTHH%3Amm%3Ass")
  .replace("M", "")
  .replace("M", "")
  .replace("P", "A")
  .replace("P", "A");
const date = currentDate.format();
const initialState = {
  currentTime: formattedDate,
  currentTimeDiff: date,
  duration: 30,
  offSet: 0,
};

const timeSlice = createSlice({
  name: "time",

  initialState,
  reducers: {
    addTime: (state, { payload }) => {
      state.currentTime = payload;
    },
    addDuration: (state, { payload }) => {
      state.duration = payload;
    },
    addTimeDiff: (state, { payload }) => {
      state.currentTimeDiff = payload;
    },
    addOffSet: (state, { payload }) => {
      state.offSet = payload;
    },
    deleteTime: (state) => {
      state.currentTime = "";
      state.currentTimeDiff = "";
      state.duration = 30;
      state.offSet="0";
    },
  },
});
export const { addTime, addTimeDiff, deleteTime, addDuration,addOffSet } =
  timeSlice.actions;

export default timeSlice.reducer;
